/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ComponentTypeBadge } from 'apps/component-service/src/Screens/AllComponents/elements/ComponentTypeBadge/ComponentTypeBadge';
import React from 'react';
import { COMPONENT_SET_DETAILS_CONSTANTS } from '../../../../../Screens/ComponentSetDetails/ComponentSetDetails.constants';
import { truncateDisplayString } from '../../../../../Utilities/TruncateDisplayString/TruncateDisplayString';
import { MaterialIcon } from '../../../../MaterialIcon/MaterialIcon';
import { ADD_COMPONENT_TO_SET_DATA_IDS } from '../../../AddComponentToSet.constants';
import { AvailableComponentsFormComponentProps } from './AvailableComponentsFormComponent.props';

/**
 * Individual component for available components.
 * @param {AvailableComponentsFormComponentProps} props Props passed to `<AvailableComponentsFormComponent />`.
 * @export
 * @returns {JSX.Element} The `<AvailableComponentsFormComponent />` component.
 */
export const AvailableComponentsFormComponent = (props: AvailableComponentsFormComponentProps): JSX.Element => {
  const { component, componentID, handleSelect, isInComponentSet } = props;
  const icon = component.latestVersion.icon;
  const componentType = props.component.latestVersion.type;
  return (
    <div className="add-to-set__item">
      <button
        className={`add-to-set__link ${isInComponentSet ? 'add-to-set__link-non-selectable' : ''}`}
        data-id={ADD_COMPONENT_TO_SET_DATA_IDS.componentItem}
        onClick={(): void => {
          handleSelect({ component, componentID });
        }}
      >
        <div className="add-to-set__card">
          <div className="add-to-set__body">
            {/* Component Title & Path */}
            <div className="add-to-set__header">
              <div className="add-to-set__icon">
                {icon ? <MaterialIcon color={icon.color.value} name={icon.id} /> : <MaterialIcon />}
              </div>
              <div className="add-to-set__header-text">
                <span className="add-to-set__title">
                  {truncateDisplayString(
                    component.latestVersion.displayName,
                    COMPONENT_SET_DETAILS_CONSTANTS.maxDisplayNameLength,
                  )}
                </span>
                <span className="add-to-set__subtitle">{componentID}</span>
              </div>
            </div>
            <div className="add-to-set__footer">
              <ComponentTypeBadge componentType={componentType} />
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};
